module.exports = __webpack_public_path__ + "fonts/iconfont.c8ff1601.ttf";